import React from "react";
import theme from "../../../styles/theme";



const Page44 = () => {
  return (

    <div>
    <h2>"Page 44" </h2>
    </div>

  );
};

export default Page44;
